import { styled } from "@mui/material/styles";

import { Content, Terms } from "pages/Search/components/styles";
import Placeholder from "components/Placeholder";

const SkeletonPill = styled(Placeholder)(({ theme }) => ({
  height: 33,
  borderRadius: "16.5px",
  [theme.breakpoints.up("mobile")]: {
    height: 50,
    borderRadius: "25px",
  },
  [theme.breakpoints.up("tablet")]: {
    height: 62,
    borderRadius: "31px",
  },
}));

const skeletons = Array.from({ length: 8 });

const SearchTermsSkeleton = () => (
  <Content data-testid="SearchTermsSkeleton">
    <Terms>
      {skeletons.map((_, i) => (
        <SkeletonPill key={i} variant="rounded" width="100%" />
      ))}
    </Terms>
  </Content>
);

export default SearchTermsSkeleton;
